import { CreatePasswordForm } from "@modules";

export const PageCreatePassword = () => {
  return <CreatePasswordForm />;
};
